var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.myself !== null && _vm.tplchoosed != null)?_c('v-container',{attrs:{"fluid":"","row":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","fill-height":""}},[_c(_vm.tplchoosed,{ref:"mysun",tag:"component",attrs:{"myself":_vm.myself}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }